@if (question.contextValue) {
  <div class="grid-x">
    <div class="small-12 medium-6 align-self-center">{{question.summaryDisplay}}</div>
    <div class="small-12 medium-6 align-self-center" [attr.role]="question.isPending ? 'alert' : null" [ngClass]="{'pending': question.isPending}">
      @switch (question.type) {
        @case (questionKind.FileUpload) {
          <file-upload-display class="summary-item-value" [summary]="this.summaryComponent" [isPreview]="isPreview" [question]="question" ></file-upload-display>
        }
        @case (questionKind.Textbox) {
          <textbox-display class="summary-item-value" [summary]="this.summaryComponent" [isPreview]="isPreview" [question]="question"></textbox-display>
        }
        @case (questionKind.NewCasingPlan) {
          <go-to-page-display class="summary-item-value" [summary]="this.summaryComponent" [isPreview]="isPreview" [question]="question" [message]="'View Casing Plan'"></go-to-page-display>
        }
        @case (questionKind.CasingPlanGrid) {
          <go-to-page-display class="summary-item-value" [summary]="this.summaryComponent" [isPreview]="isPreview" [question]="question" [message]="'View Casing Plan'"></go-to-page-display>
        }
        @case (questionKind.CasingPlanSchematic) {
          <go-to-page-display class="summary-item-value" [summary]="this.summaryComponent" [isPreview]="isPreview" [question]="question" [message]="'View Schematic'"></go-to-page-display>
        }
        @case (questionKind.FileParser) {
          <go-to-page-display class="summary-item-value" [summary]="this.summaryComponent" [isPreview]="isPreview" [question]="question" [message]="'View Parsed Data'"></go-to-page-display>
        }
        @case (questionKind.Checkbox) {
          <checkbox-display class="summary-item-value" [summary]="this.summaryComponent" [isPreview]="isPreview" [question]="question"></checkbox-display>
        }
        @case (questionKind.DataQueryButton) {
          <query-button-display class="summary-item-value" [summary]="this.summaryComponent" [isPreview]="isPreview" [question]="question"></query-button-display>
        }
        @case (questionKind.DatePicker) {
          <date-picker-display class="summary-item-value" [summary]="this.summaryComponent" [isPreview]="isPreview" [question]="question"></date-picker-display>
        }
        @case (questionKind.Dropdown) {
          <domain-driven-display class="summary-item-value" [summary]="this.summaryComponent" [isPreview]="isPreview" [question]="question" [domains]="summaryComponent.domains"></domain-driven-display>
        }
        @case (questionKind.MultiselectCheckbox) {
          <domain-driven-display class="summary-item-value" [summary]="this.summaryComponent" [isPreview]="isPreview" [question]="question" [domains]="summaryComponent.domains"></domain-driven-display>
        }
        @default {
          <default-display class="summary-item-value" [summary]="this.summaryComponent" [isPreview]="isPreview" [question]="question"></default-display>
        }
      }
      @if (valueHasChanged) {
        <span (mouseover)="toggleShowInitialValue(true)" (mouseout)="toggleShowInitialValue(false)"><svg-icon aria-hidden="true" icon="icon-delta" class="tiny light-blue"></svg-icon></span>
        }<span [ngClass]="showInitialValue ? 'show-full-text' : 'hide-full-text'">{{originalValue}}</span>
        @if (question.isPending) {
          <span class="show-for-sr">Missing Required Information!</span>
        }
        @if (question.isPending) {
          <svg-icon aria-hidden="true" icon="icon-alert" class="small minor-margin-left" [attr.role]="question.isPending ? 'alert': null"></svg-icon>
        }
        @if (showNotes) {
          <button class="minor-margin-left" attr.aria-label="Show Note for '{{question.summaryDisplay}}" (click)="addNote($event, question.contextValue)">
            <svg-icon class="note-icon cursor-pointer" [icon]="noteIcon">
            </svg-icon>
          </button>
        }
      </div>
    </div>
  } @else {
    <div class="summary-item-heading">{{question.summaryDisplay}}</div>
  }

